module.exports = __webpack_public_path__ + "static/media/1.c1f0aa56.png";